module.exports = __webpack_public_path__ + "ee6cc7dadf90ebae6d1b3b8d04cc330c.png";